<template>
  <Fragment>
    <comopnent
      :is="componentName"
      v-for="(item, index) in node.children"
      v-bind="$attrs"
      :key="item.id"
      :node="item"
      :class="{
        'mod--first': index === 0,
        'mod--last': index === node.children.length - 1,
      }"
      v-on="$listeners || {}"
    />
  </Fragment>
</template>

<script>
import { Fragment } from 'vue-fragment'

export const LEVELS = {
  ROOT: 0,
  REGIONS: 1,
  MUNICIPALITIES: 2,
  SCHOOLS: 3,

  ROADMAPS: 4,
  DIRECTIONS: 5,
  EVENTS: 6,
  FILES: 7,
}

export default {
  name: 'LKRoadmapsFeedTreeChildren',
  components: {
    Fragment,
  },
  props: {
    node: {
      type: Object,
      required: true,
    },
  },
  computed: {
    componentName() {
      switch (this.node.level + 1) {
        case LEVELS.REGIONS:
        case LEVELS.MUNICIPALITIES:
        case LEVELS.SCHOOLS:
          return () => import(
            /* webpackChunkName: "LKRoadmapsFeedTreeAteDrop" */
            './TreeAteDrop/LKRoadmapsFeedTreeAteDrop.vue'
          )

        case LEVELS.ROADMAPS:
          return () => import(
            /* webpackChunkName: "CardRoadmap" */
            './CardRoadmap/LKRoadmapsFeedCardRoadmap.vue'
          )

        default:
          return () => import(
            /* webpackChunkName: "LKRoadmapsFeedTreeAteDrop" */
            './TreeAteDrop/LKRoadmapsFeedTreeAteDrop.vue'
          )
      }
    },
  },
}
</script>
